// Lib
import * as _ from 'lodash';
import { put, call, takeLatest, debounce } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMSpecialHoursAPI, getLMSpecialHoursAPIError, getLMSpecialHoursAPISuccess, ActionPostLMSpecialHoursAPI, postLMSpecialHoursAPIError, postLMSpecialHoursAPISuccess } from './actions';
import { LMspecialHours } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMspecialHours } from './utils';

function* getDealerLMspecialHours(action: ActionGetLMSpecialHoursAPI) {
  try {
    const { listingId } = action;
    const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/specialHours`);
    const lmspecialHours: LMspecialHours = parseAPILMspecialHours(data);
    yield put(getLMSpecialHoursAPISuccess(lmspecialHours));
  } catch (err) {
    yield put(getLMSpecialHoursAPIError());
  }
}

function* postDealerLMSpecialHours(action: ActionPostLMSpecialHoursAPI) {
  try {
    const { listingId, specialHoursData } = action;
    const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/specialHours`, specialHoursData);
    const lmspecialHours: LMspecialHours = parseAPILMspecialHours(response.data);
    yield put(postLMSpecialHoursAPISuccess(lmspecialHours));
  } catch (err) {
    yield put(postLMSpecialHoursAPIError());
  }
}

export default function* EngineSpecialHourSagas() {
  yield takeLatest(ACTIONS.GET_LMSPECIALHOURS_API_REQUEST, getDealerLMspecialHours);
  yield takeLatest(ACTIONS.POST_LMSPECIALHOURS_API_REQUEST, postDealerLMSpecialHours);
}